import { createFileRoute } from "@tanstack/react-router"
import { ForgotPasswordForm } from "@/components/ui/auth/ForgotPasswordForm"

export const Route = createFileRoute("/forgot-password")({
  component: ForgotPasswordPage,
})

function ForgotPasswordPage() {
  return <ForgotPasswordForm />
}
